import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Wrap remote image URLs with Cloudinary "fetch" optimization when configured.
// Set REACT_APP_CLOUDINARY_CLOUD_NAME in your .env.local to enable.
export function getOptimizedImageUrl(
  originalUrl,
  {
    width = 800,
    height = 600,
    crop = "fill",
    quality = "auto",
    format = "auto",
  } = {}
) {
  if (!originalUrl) return originalUrl;

  const isRemoteUrl = /^https?:\/\//i.test(originalUrl);
  if (!isRemoteUrl) {
    return originalUrl;
  }

  const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
  if (!cloudName) {
    // Fallback to the raw URL when Cloudinary is not configured
    return originalUrl;
  }

  const base = `https://res.cloudinary.com/${cloudName}/image/fetch`;
  const transform = `w_${width},h_${height},c_${crop},q_${quality},f_${format}`;

  // Encode the remote URL so Cloudinary parses it correctly
  const encodedSource = encodeURIComponent(originalUrl);

  return `${base}/${transform}/${encodedSource}`;
}
